/*
 * Hauser MX — "Tu recorrido" (Fase 4).
 *
 * Convierte el carrito de Shopify en un itinerario de visitas:
 *  - agregar una propiedad SIEMPRE con cantidad 1 (nunca acumula);
 *  - quitar propiedades;
 *  - contador global en vivo;
 *  - drawer y página sincronizados sin recargar;
 *  - mensaje de WhatsApp armado desde el estado real del carrito.
 *
 * Usa exclusivamente la Cart AJAX API nativa de Shopify. Sin dependencias
 * externas, sin apps. No toca inventario, precios ni metafields.
 */
(function () {
  'use strict';

  var SEL = {
    drawer: '[data-hauser-recorrido-drawer]',
    cuerpo: '[data-hauser-recorrido-cuerpo]',
    abrir: '[data-hauser-recorrido-abrir]',
    cerrar: '[data-hauser-recorrido-cerrar]',
    quitar: '[data-hauser-recorrido-quitar]',
    agregar: '[data-hauser-recorrido-agregar]',
    contador: '[data-hauser-recorrido-contador]',
    whatsapp: '[data-hauser-recorrido-whatsapp]',
    abrirForm: '[data-hauser-recorrido-abrir-form]',
    form: '[data-hauser-recorrido-form]',
  };

  var enVuelo = false;

  function texto(n) {
    return n === 1 ? '1 propiedad en tu recorrido' : n + ' propiedades en tu recorrido';
  }

  /* ---------- Estado del carrito ---------- */

  function leerCarrito() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    }).then(function (r) {
      return r.json();
    });
  }

  function actualizarContador(count) {
    document.querySelectorAll(SEL.contador).forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.hidden = count === 0;
      var host = el.closest('[data-hauser-recorrido-enlace]');
      if (host) host.setAttribute('aria-label', texto(count));
    });
  }

  /* ---------- Re-render sin recargar ----------
   *
   * El enlace de WhatsApp NO se arma en JS a propósito: el carrito de la
   * Cart AJAX API no expone los metafields, así que no conoce
   * `propiedad.zona`. El servidor sí, y ya lo incluye en el href al
   * renderizar 'hauser-recorrido-lista'. Como el refresco de abajo trae el
   * HTML re-renderizado, el enlace llega siempre correcto y completo.
   */

  function refrescarVistas() {
    return fetch(window.location.pathname + '?t=' + Date.now(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevos = doc.querySelectorAll(SEL.cuerpo);
        var actuales = document.querySelectorAll(SEL.cuerpo);
        // El drawer vive en el layout y la página en su sección: ambos
        // comparten el mismo selector, así que el orden coincide.
        actuales.forEach(function (el, i) {
          if (nuevos[i]) el.innerHTML = nuevos[i].innerHTML;
        });
      })
      .catch(function () {
        /* Si el re-render falla, el contador ya quedó correcto. */
      });
  }

  function sincronizar() {
    return leerCarrito().then(function (cart) {
      actualizarContador(cart.item_count);
      return refrescarVistas().then(function () {
        return cart;
      });
    });
  }

  /* ---------- Acciones ---------- */

  function anunciar(msg) {
    var region = document.getElementById('hauser-recorrido-anuncio');
    if (region) region.textContent = msg;
  }

  function confirmar(boton, mensaje) {
    if (!boton) return;
    var original = boton.dataset.textoOriginal || boton.textContent.trim();
    boton.dataset.textoOriginal = original;
    boton.classList.add('is-confirmado');
    boton.textContent = mensaje;
    window.setTimeout(function () {
      boton.classList.remove('is-confirmado');
      boton.textContent = original;
    }, 2600);
  }

  function agregar(boton) {
    var id = boton.getAttribute('data-variante');
    if (!id || enVuelo) return;
    enVuelo = true;

    // Cantidad FIJA de 1: si ya está en el recorrido no se vuelve a sumar.
    leerCarrito()
      .then(function (cart) {
        var yaEsta = cart.items.some(function (i) {
          return String(i.variant_id) === String(id);
        });
        if (yaEsta) return null;
        return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        });
      })
      .then(function (res) {
        if (res === null) {
          confirmar(boton, 'Ya está en tu recorrido');
          anunciar('Esta propiedad ya estaba en tu recorrido.');
          return null;
        }
        return sincronizar().then(function () {
          confirmar(boton, 'Agregada a tu recorrido ✓');
          anunciar('Propiedad agregada a tu recorrido.');
          abrirDrawer();
        });
      })
      .catch(function () {
        confirmar(boton, 'No se pudo agregar');
      })
      .finally(function () {
        enVuelo = false;
      });
  }

  function quitar(boton) {
    var linea = boton.getAttribute('data-linea');
    if (!linea || enVuelo) return;
    enVuelo = true;

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(linea), quantity: 0 }),
    })
      .then(function () {
        return sincronizar();
      })
      .then(function (cart) {
        anunciar(cart && cart.item_count === 0 ? 'Tu recorrido quedó vacío.' : 'Propiedad quitada de tu recorrido.');
      })
      .catch(function () {})
      .finally(function () {
        enVuelo = false;
      });
  }

  /* ---------- Drawer ---------- */

  function abrirDrawer() {
    var d = document.querySelector(SEL.drawer);
    if (!d) return;
    d.hidden = false;
    document.body.classList.add('hauser-recorrido-abierto');
    window.requestAnimationFrame(function () {
      d.classList.add('is-abierto');
    });
    var cerrar = d.querySelector(SEL.cerrar);
    if (cerrar) cerrar.focus();
  }

  function cerrarDrawer() {
    var d = document.querySelector(SEL.drawer);
    if (!d) return;
    d.classList.remove('is-abierto');
    document.body.classList.remove('hauser-recorrido-abierto');
    window.setTimeout(function () {
      d.hidden = true;
    }, 260);
  }

  /* ---------- Enlaces ---------- */

  document.addEventListener('click', function (e) {
    var agregarBtn = e.target.closest(SEL.agregar);
    if (agregarBtn) {
      e.preventDefault();
      agregar(agregarBtn);
      return;
    }

    var quitarBtn = e.target.closest(SEL.quitar);
    if (quitarBtn) {
      e.preventDefault();
      quitar(quitarBtn);
      return;
    }

    var abrirBtn = e.target.closest(SEL.abrir);
    if (abrirBtn) {
      e.preventDefault();
      abrirDrawer();
      return;
    }

    if (e.target.closest(SEL.cerrar)) {
      e.preventDefault();
      cerrarDrawer();
      return;
    }

    var formBtn = e.target.closest(SEL.abrirForm);
    if (formBtn) {
      e.preventDefault();
      var caja = formBtn.closest(SEL.cuerpo) || document;
      var form = caja.querySelector(SEL.form);
      if (form) {
        var abierto = !form.hidden;
        form.hidden = abierto;
        formBtn.setAttribute('aria-expanded', String(!abierto));
        if (!abierto) {
          var primero = form.querySelector('input, textarea');
          if (primero) primero.focus();
        }
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarDrawer();
  });

  // Si el formulario nativo se envió con éxito, Shopify recarga con
  // ?contact_posted=true — abrimos el form para mostrar la confirmación.
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.search.indexOf('contact_posted=true') !== -1) {
      document.querySelectorAll(SEL.form).forEach(function (f) {
        f.hidden = false;
      });
    }
  });
})();
